import { pgSchema } from "drizzle-orm/pg-core";

// Shared schema
export const sharedSchema = pgSchema("Shared");
